<template>
  <div>
    <v-expansion-panel-header class="primary">
      <h4 class="mx-2 mb-0 white--text">{{addressSection.Title}}</h4>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-layout row wrap>
            <v-flex lg6 xl6 sm6 md6 xs12>
              <v-text-field
                v-model="userInfo.firstName"
                :rules="inputRules.basictextRules"
                :label="addressSection.First_Name_Placeholder"
                required
              ></v-text-field>
            </v-flex>

            <!-- <v-flex lg4 xl4 xs12 sm6 md6>
              <v-text-field
                v-model="userInfo.lastName"
                :rules="inputRules.basictextRules"
                :label="addressSection.Last_Name_Placeholder"
                required
              ></v-text-field>
            </v-flex>-->

            <v-flex lg6 xl6 sm6 md6 xs12>
              <v-text-field
                v-model="userInfo.streetName"
                :rules="inputRules.basictextRules"
                :label="addressSection.Street_No_Placeholder"
                required
              ></v-text-field>
            </v-flex>
            <v-flex lg6 xl6 sm6 md6 xs12>
              <v-text-field
                v-model="userInfo.aptBuilding"
                :rules="inputRules.basictextRules"
                :label="addressSection.Building_Name_Placeholder"
                required
              ></v-text-field>
            </v-flex>
            <v-flex lg6 xl6 md6 sm6 xs12>
              <v-text-field
                v-model="userInfo.state"
                :rules="inputRules.basictextRules"
                :label="addressSection.State_Placeholder"
                required
              ></v-text-field>
            </v-flex>
            <v-flex lg6 xl6 md6 sm6 xs12>
              <v-text-field
                v-model="userInfo.city"
                :rules="inputRules.basictextRules"
                :label="addressSection.City_Placeholder"
                required
              ></v-text-field>
            </v-flex>
            <v-flex lg6 xl6 md6 sm6 xs12>
              <v-text-field
                v-model="userInfo.country"
                :rules="inputRules.basictextRules"
                :label="addressSection.Country_Placeholder"
                required
              ></v-text-field>
            </v-flex>
            <v-flex lg6 xl6 sm6 md6 xs12>
              <v-text-field
                v-model="userInfo.zipCode"
                :rules="inputRules.basictextRules"
                :label="addressSection.ZipCode_Placeholder"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <div class="contact-info d-block pt-4">
            <h4>{{addressSection.Contact_Info_Title}}</h4>
            <v-layout row wrap>
              <v-flex lg6 xl6 md6 sm12>
                <v-text-field
                  v-model="userInfo.phone"
                  :rules="inputRules.basictextRules"
                  :label="addressSection.Contact_Number_Placeholder"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex lg6 xl6 md6 sm12>
                <v-text-field
                  v-model="userInfo.email"
                  :rules="inputRules.emailRules"
                  :label="addressSection.Email_Placeholder"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex lg6 xl6 md6 sm6>
                <div class="share-block">
                  <h4>{{addressSection.Shipping_Address_Label}}</h4>
                  <v-select
                    :items="shippingAddressDatas"
                    v-model="userInfo.shippingAddress"
                    required
                    item-text="keyword1"
                    item-value="id"
                    return-object
                    :rules="inputRules.basictextRules"
                    class="mt-0 pt-0"
                  ></v-select>
                </div>
              </v-flex>
              <v-flex>
                <div>
                  <p>{{userInfo.shippingAddress.keyword4}}</p>
                  <p>{{userInfo.shippingAddress.keyword3}}</p>
                  <p>{{userInfo.shippingAddress.keyword6}}</p>
                </div>
              </v-flex>
              <!-- <v-flex lg6 xl6 md6 sm6>
                <div class="share-block">
                  <h4>{{addressSection.Share_with_others_title}}</h4>
                  <p>{{addressSection.Description}}</p>
                  <v-text-field
                    v-model="userInfo.sharedEmail"
                    :label="addressSection.Email_Placeholder"
                  ></v-text-field>
                </div>
              </v-flex>-->
            </v-layout>
          </div>
          <div class="layout justify-start px-4">
            <v-btn
              pl-0
              ml-0
              large
              @click="addUserDetails"
              class="accent"
            >{{addressSection.Button_Label}}</v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, {
  moment,
});
export default {
  props: ["changeStepOneForm", "addressSection"],
  data() {
    return {
      cmsRequestFunctions: null,
      // addressSection: "",
      valid: false,
      userInfo: {
        firstName: "",
        streetName: "",
        aptBuilding: "",
        zipCode: "",
        city: "",
        state: "",
        country: "",
        phone: "",
        email: "",
        shippingAddress: "",
      },
      shippingAddressDatas: [],
      billingAddressData: [],

      // shippingAddress: "",
      inputRules: {},
      // shippingAddressData: [],
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.readBillingAddress();
    this.readShippingAddress();
    try {
      var userInformation = JSON.parse(localStorage.embryo);
      this.userInfo.phone = userInformation.user_data.phoneNumber;
      this.userInfo.email = userInformation.user_data.email;
    } catch (error) {
      console.log("Not Email And Phone");
    }
    this.inputRules = {
      basictextRules: [
        (v) => !!v || this.cmsRequestFunctions.getValidationMsgByCode("M026"),
      ],
      emailRules: [
        (v) => !!v || this.cmsRequestFunctions.getValidationMsgByCode("M026"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.cmsRequestFunctions.getValidationMsgByCode("M010"),
      ],
    };
  },
  methods: {
    addUserDetails() {
      this.$refs.form.validate();
      if (this.valid == true) {
        this.$emit("changeStepOneForm");
        this.$store.dispatch("addUserDetails", this.userInfo);
      }
    },
    readBillingAddress: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      self.userData = JSON.parse(user);
      self.loginDetails = self.userData.user_data;
      var userName = self.loginDetails.loginId;
      self.email = self.loginDetails.email;
      var filterValue =
        "type='Billing Address' AND keyword12='" + userName + "'";
      var allData = await self.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        self.billingAddressData = allData.data.data;
        if (self.billingAddressData.length) {
          self.billingAddressData = self.billingAddressData[0];
          self.userInfo.firstName = self.billingAddressData.keyword1;
          self.userInfo.streetName = self.billingAddressData.keyword3;
          self.userInfo.aptBuilding = self.billingAddressData.keyword4;
          self.userInfo.zipCode = self.billingAddressData.keyword5;
          self.userInfo.city = self.billingAddressData.keyword13;
          self.userInfo.state = self.billingAddressData.keyword6;
          self.userInfo.country = self.billingAddressData.keyword7;
        }
      } else {
        console.log("error:", allData);
      }
    },
    readShippingAddress: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      self.userData = JSON.parse(user);
      self.loginDetails = self.userData.user_data;
      var userName = self.loginDetails.loginId;
      self.email = self.loginDetails.email;
      var filterValue =
        "type='Shipping Address' AND keyword12='" + userName + "'";
      var allData = await self.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        self.shippingAddressDatas = allData.data.data;
        if (self.shippingAddressDatas.length) {
          self.userInfo.shippingAddress = self.shippingAddressDatas.find(
            (element) => {
              return element.bool1;
            }
          );
        } else {
          router.push("/account/address?to=checkout");
        }
      } else {
        console.log("error:", allData);
      }
    },
  },
};
</script>